module.exports = __webpack_public_path__ + "static/media/spam_off.736c2a62.svg";